import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/style';
import Button from 'components/CustomButtons/Button';

import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';

import Close from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => {
  return <Slide direction='up' ref={ref} {...props} />;
});

class SweetModal extends Component {
  applyClassTitle = (element, sx) =>
    element && element.props && element.props.children
      ? React.cloneElement(element, {
          children: React.Children.map(element.props.children, (child) =>
            child && child.type === 'h4' ? React.cloneElement(child, { sx }) : this.applyClassTitle(child, sx),
          ),
        })
      : element;

  render() {
    const {
      title,
      isOpen,
      uploadInput,
      inputs,
      submit,
      noSubmit,
      noCancel,
      noClose,
      cancelText,
      submitText,
      submitFullWidth,
      submitDisabled,
      toggleModal,
      fullScreen,
      fullWidth,
      key,
      maxWidth,
      withBackground,
      customFooter,
      className,
      contentStyle,
    } = this.props;

    const getWidth = () => {
      if (fullWidth) return '100%';
      if (maxWidth === 'lg') return '100%';
      if (maxWidth === 'md') return 695;
      return 384;
    };

    return (
      <Dialog
        key={key}
        slotProps={{
          paper: {
            sx: {
              width: getWidth(),
              maxWidth: '100%',
              overflowY: 'visible',
              '@media screen and (max-width: 455.95px)': {
                width: '100vw',
                height: '100vh',
                maxHeight: 'unset',
                margin: 0,
                paddingTop: '40px',
                borderRadius: 0,
              },
            },
          },
        }}
        sx={{
          ...style.root,
          ...(className ? { className } : {}),
        }}
        open={isOpen}
        fullScreen={fullScreen || false}
        fullWidth={fullWidth || false}
        maxWidth={fullWidth ? false : maxWidth}
        TransitionComponent={Transition}
        keepMounted
        onClose={toggleModal}
        aria-labelledby='classic-modal-slide-title'
        aria-describedby='classic-modal-slide-description'>
        <DialogTitle component='div' id='classic-modal-slide-title' sx={style.modalHeader}>
          {!noClose && (
            <IconButton
              sx={style.modalCloseContainer}
              key='close'
              aria-label='Close'
              color='inherit'
              onClick={toggleModal}
              edge={'start'}
              size='large'>
              <Box component='span' sx={style.modalCloseLabel}>
                Fermer
              </Box>
              <Box sx={style.modalCloseButton}>
                <Close sx={style.modalClose} />
              </Box>
            </IconButton>
          )}
          {React.isValidElement(title) ? (
            this.applyClassTitle(title, style.modalTitle)
          ) : (
            <Typography component='h4' sx={style.modalTitle}>
              {title}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent
          id='classic-modal-slide-description'
          sx={{
            ...style.modalBody,
            ...(withBackground ? style.modalBodyGrayBackground : {}),
            ...contentStyle,
            '&.MuiDialogContent-root': {
              paddingTop: '24px',
            },
          }}>
          {inputs}
        </DialogContent>
        <DialogActions sx={style.modalFooter}>
          {uploadInput !== undefined && <Box sx={style.uploadInput}>{uploadInput}</Box>}

          {!noCancel && (
            <Button onClick={toggleModal} fullWidth={submitFullWidth} color='lightGray'>
              {cancelText || 'Annuler'}
            </Button>
          )}
          {!noSubmit && (
            <Button color='primary' fullWidth={submitFullWidth} onClick={submit} disabled={submitDisabled}>
              {submitText || 'Valider'}
            </Button>
          )}

          {noSubmit && noCancel && customFooter !== undefined && customFooter}
        </DialogActions>
      </Dialog>
    );
  }
}

SweetModal.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    PropTypes.oneOf([null]).isRequired,
  ]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  inputs: PropTypes.node.isRequired,
  toggleModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  submit: PropTypes.func,
  noSubmit: PropTypes.bool,
  cancelText: PropTypes.string,
  uploadInput: PropTypes.node,
  key: PropTypes.string,
  submitText: PropTypes.string,
  submitFullWidth: PropTypes.bool,
  noCancel: PropTypes.bool,
  noClose: PropTypes.bool,
  withBackground: PropTypes.bool,
  customFooter: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', null]),
  submitDisabled: PropTypes.bool,
};

SweetModal.defaultProps = {
  submitFullWidth: false,
  withBackground: false,
  maxWidth: 'sm',
  submitDisabled: false,
};

export default SweetModal;
